module.exports = __webpack_public_path__ + "static/curb-close-up-bg-1200x600-a6fe0f9f15955b23566d97278e55769f.jpg";